<template>
  <v-snackbar v-model="visible" color="blue darken-2" :timeout="5000" top>

    {{ $t('actualisation', {count: $account.current.rules['check-position'].max_monitor_refresh_interval_hours}) }}

    <span class="white--text" style="text-decoration: underline; cursor: pointer;" @click="subscribe()">
      {{ $t('subscription') }}
    </span> !

    <template v-slot:action="{ attrs }">
      <v-btn v-if="$vuetify.breakpoint.smAndUp" @click="subscribe()" light elevation="0" class="primary--text mr-2" v-bind="attrs">
        {{ $t('actions.subscribe') }}
      </v-btn>
      <v-btn text v-bind="attrs" @click="visible = false">
        {{ $t('actions.close') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'PaymentRequiredForMoreMonitorRefreshNotification',
  data () {
    return {
      visible: false
    }
  },
  methods: {
    subscribe () {
      this.visible = false
      this.$router.push('account/subscriptions')
    }
  },
  mounted () {
    this.$bus.on('notification/payment_required_for_more_monitor_refresh', () => {
      this.visible = true
    })
  }
}
</script>

<i18n>
{
	"en": {
		"actualisation": " Please wait {count} hour(s) between each update, or",
		"subscription": "subscribe to an offer to increase this limit"
	},
	"es": {
		"actualisation": " Espere {count} hora(s) entre cada actualización o",
		"subscription": "suscríbete a una oferta para aumentar este límite"
	},
	"fr": {
		"actualisation": " Merci de patienter {count} heure(s) entre  chaque actualisation, ou",
		"subscription": "souscrivez à une offre pour augmenter cette limite"
	},
	"it": {
		"actualisation": " Attendi {count} ora/e tra ogni aggiornamento, o",
		"subscription": "abbonati a un'offerta per aumentare questo limite"
	},
	"pt": {
		"actualisation": " Por favor aguarde {count} hora(s) entre cada atualização, ou",
		"subscription": "subscreva uma oferta para aumentar este limite"
	},
	"pl": {
		"actualisation": " Poczekaj {count} godzinę/godziny między każdą aktualizacją lub",
		"subscription": "subskrybuj ofertę, aby zwiększyć ten limit"
	}
}
</i18n>


